export const updateLogo="Update My Logo";
export const noPermission="No Permission";
export const siteMap="Site Map";
export const searchList="Search Result";
export const contactUs="Contact Us";
export const guideline="My-invoice Guideline";
export const transaction="Transaction Data Management";
export const view="View";
export const operationLog="Operation Log";
export const invoiceIssuance="Modify & Issue";
export const selectBuyer="Select Buyer";
export const selectSupplier="Select Supplier";
export const addPayment="Add Payment";
export const addAddition="Add Additional Charge";
export const modifyAddition="Modify Additional Charge";
export const addTax="Add Tax Details";
export const modifyTax="Modify Tax Details";
export const addItem="Add Item";
export const selectGoods="Select Item";
export const modifyItem="Modify Item";
export const invoiceUpload="Upload";
export const invoiceUploadRecords="Uploaded Records";
export const add="Add";
export const viewInvalidReasons="View Invalid Reasons";
export const purchase="My Purchase Invoices";
export const rejectInvoice="Rejection";
export const invoice="Invoice Management";
export const cancelInvoice="Cancellation";
export const shareInvoice="Share Invoice PDF";
export const myProfile="View My Profile";
export const taxpayerInfo="Taxpayer's Info Maintenance";
export const batchImportPage="Batch Import";
export const taxpayerDetail="Contract Details";
export const contractView="Contract View";
export const userBinding="User Binding";
export const roleManagement="Role Management";
export const viewOperationLog="View Operation Logs";
export const debitNoteList="Debit Note Management";
export const selectInvoiceList="Select Invoice";
export const debitNoteForm="Request Debit Note";
export const credit="Credit Note Management";
export const creditNoteForm="Request Credit Note";
export const refund="Refund Note Management";
export const refundNoteForm="Request Refund Note";
export const invoicingConsolidated="Invoicing Consolidated Management";
export const transactionConsolidatedForm="Invoice Preview";
export const viewItem="View Item";
export const viewItemTax="View Item Tax";
export const viewTax="View Tax Details";
export const transactionSeparatedManagement="View Transaction Data";
export const report="Operation Log Report";
export const operationDetails="View Details";
export const downloadTask="Download Task";
export const viewDetails='View Details';
export const goodsService="Product & Services";
export const modify="Modify";
export const frequentContacts="Supplier & Buyer";
export const consolidateTaskList="Transaction Consolidated Task";
export const consolidateTaskForm="Run Consolidate Task";
export const failureReason="View Failure Reasons";